import { render, staticRenderFns } from "./thumbnail2fa.vue?vue&type=template&id=31679360&scoped=true&"
import script from "./thumbnail2fa.vue?vue&type=script&lang=js&"
export * from "./thumbnail2fa.vue?vue&type=script&lang=js&"
import style0 from "./thumbnail2fa.vue?vue&type=style&index=0&id=31679360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31679360",
  null
  
)

export default component.exports